import PlanDetailsTable from '../../../components/plan-details-sales-table/plan-details-table';
import {
  ContainerPlanInfo,
  HeaderContainer,
  HeaderImage,
  HeaderText,
  MainContainer,
  TableContainer
} from './plan-info-sales-style';
import { createNewPlans } from './plans-list';

const PlansInfoSales = () => {
  const plansForTable = createNewPlans();

  return (
    <>
      <ContainerPlanInfo>
        <MainContainer>
          <HeaderContainer>
            <HeaderImage src={'/assets/images/logo.png'} alt={'LOGO'} />
            <div>
              <HeaderText>
                Tabela de Preços e Planos - Oficial Atualizada em
                <strong> 10/07/2025</strong>
              </HeaderText>
            </div>
          </HeaderContainer>

          <TableContainer>
            <PlanDetailsTable plansData={plansForTable} />
          </TableContainer>
        </MainContainer>
      </ContainerPlanInfo>
    </>
  );
};

export default PlansInfoSales;
